import type { MealPeriodTab } from '~/lib/mealPeriod/tab'
import type { AdditionalCriteria } from '~/navigation'
import {
  useApplyCriteriaChange,
  useApplyMealPeriodChange,
  useInitCalendar,
  useOnClearCondition,
  useOnMealPeriodChange,
  useOnVisitConditionChange,
} from '~/stores/calendar/state'
import type { OnMealPeriodChange, OnVisitConditionChange } from '~/stores/calendar/state'
import type { InitEvent } from '~/stores/calendar/statemachine'

export function InitAtom({
  initEvent,
  criteria,
  onVisitConditionChange,
  mealPeriod,
  onMealPeriodChange,
  onClearCondition,
}: {
  initEvent: InitEvent
  criteria?: AdditionalCriteria
  onVisitConditionChange?: OnVisitConditionChange
  mealPeriod?: MealPeriodTab
  onMealPeriodChange?: OnMealPeriodChange
  onClearCondition?: () => void
}) {
  useInitCalendar(initEvent)
  useApplyMealPeriodChange(mealPeriod)
  useApplyCriteriaChange(criteria)
  useOnVisitConditionChange(onVisitConditionChange)
  useOnMealPeriodChange(onMealPeriodChange)
  useOnClearCondition(onClearCondition)
  return null
}
